import {
    GET_AMAZON_PRODUCT_INFORMATION_REQUEST,
    GET_AMAZON_PRODUCT_INFORMATION_SUCCESS,
    GET_AMAZON_PRODUCT_INFORMATION_ERROR
} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {

        case GET_AMAZON_PRODUCT_INFORMATION_REQUEST:
            return {
                loading: true,
            };
        case GET_AMAZON_PRODUCT_INFORMATION_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_AMAZON_PRODUCT_INFORMATION_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}